<ndt-tile-view
   [tileConfig]="tileConfig"
   [callState]="tile?.callState"
   [isFullscreen]="isFullscreen"
   [isEditing]="isEditing"
   [showHeader]="showHeader"
   (configureParameters)="onConfigureParameters()"
   ndtTileContainer
>
   <p tileheadername>{{ name ? name : tileConfig.dashboardTileLayoutConfiguration.name }}</p>
   <div moreactions>
      <ng-content select="[moreactions]"></ng-content>
   </div>

   <div tileInfo>
      @if (graphTileService.data) { @if (fallbackTemplateRef) {
      <ng-container *ngTemplateOutlet="fallbackTemplateRef"></ng-container>
      } @if (!fallbackTemplateRef) {
      <div class="chart-flex-container">
         <span class="chart-header-content">
            <ng-content select="[chartHeader]"></ng-content>
         </span>
         <div class="chart-content-container">
            <div class="chart-content">
               <qmg-chart-wrapper
                  #chartWrapper
                  [chartDisplayType]="chartDisplayType"
                  [colorScheme]="graphTileService.colorScheme"
                  [customLabel]="customLabel"
                  [data]="graphTileService.data"
                  [displayPieGridIndividualPies]="displayPieGridIndividualPies"
                  [doughnut]="graphTileService.doughnut"
                  [explodeSlices]="graphTileService.explodeSlices"
                  [labels]="graphTileService.labels"
                  [legend]="graphTileService.legend"
                  [legendPosition]="graphTileService.legendPosition"
                  [maxXAxisTickLength]="graphTileService.maxXAxisTickLength"
                  [rotateXAxisTicks]="graphTileService.rotateXAxisTicks"
                  [showXAxisLabel]="graphTileService.showXAxisLabel"
                  [showYAxisLabel]="graphTileService.showYAxisLabel"
                  [timeline]="graphTileService.timeline"
                  [view]="graphTileService.view"
                  [xAxisLabel]="graphTileService.xAxisLabel"
                  [xAxisTickFormatting]="graphTileService.xAxisTickFormatting"
                  [yAxisLabel]="graphTileService.yAxisLabel"
                  [xScaleMin]="graphTileService.xScaleMin"
                  [xScaleMax]="graphTileService.xScaleMax"
                  [canClickPieInGridCb]="canClickPieInGridCb"
                  (activate)="graphTileService.onActivate($event)"
                  (chartClick)="onClick($event)"
                  (deactivate)="graphTileService.onDeactivate($event)"
                  (select)="onSelect($event)"
               >
                  @if (graphTileService.customTooltipTemplateRef; as model) {
                  <ng-template #tooltipTemplateRef let-model="model">
                     <ng-container *ngTemplateOutlet="graphTileService.customTooltipTemplateRef"></ng-container>
                  </ng-template>
                  } @if (graphTileService.customSeriesTooltipTemplateRef; as model) {
                  <ng-template #seriesTooltipTemplateRef let-model="model">
                     <ng-container *ngTemplateOutlet="graphTileService.customSeriesTooltipTemplateRef"></ng-container>
                  </ng-template>
                  }
               </qmg-chart-wrapper>
            </div>
         </div>
      </div>
      } }
   </div>
   <ndt-tile-parameters
      [tileConfig]="tileConfig"
      [formService]="formService"
      *ndtTileParametersDef
      tileParametersList
   ></ndt-tile-parameters>
</ndt-tile-view>
